
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pengelolaan-kinerja-ps/pegawai/pelaksanaan/praktik-kinerja",
      function () {
        return require("private-next-pages/pengelolaan-kinerja-ps/pegawai/pelaksanaan/praktik-kinerja/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pengelolaan-kinerja-ps/pegawai/pelaksanaan/praktik-kinerja"])
      });
    }
  